import axiosInstance from './axiosInstance';

// Submit quotation (authenticated users)
export const submitQuotation = async (productId, quotationData) => {
  const response = await axiosInstance.post(`/api/quotation/${productId}`, quotationData);
  return response.data;
};

// Admin quotation endpoints
export const getAdminQuotations = async () => {
  const response = await axiosInstance.get('/api/admin/quotations');
  return response.data;
};

export const approveQuotation = async (quotationId) => {
  const response = await axiosInstance.put(`/api/admin/quotations/${quotationId}/approve`);
  return response.data;
};

export const deleteQuotation = async (quotationId) => {
  const response = await axiosInstance.delete(`/api/admin/quotations/${quotationId}`);
  return response.data;
};

const quotationService = {
  submitQuotation,
  getAdminQuotations,
  approveQuotation,
  deleteQuotation,
};

export default quotationService;
